import { animate } from 'animejs';

const blobTop = (targetCSS) => {
	animate(targetCSS, {
		d: [
			{
				value:
					'M275,31c200,0,180,120,272,270,150,90,150,212,90,390-66,150-217,120-326,160.958C170,600-150,570-200,320.906S75,120,150,50Z',
			},
			{
				value:
					'M275,31c200,50,120,190,315,316,70,50,95,225,40,295-90,52-150,120-275,70.958C170,520-160,420-150,315.906S75,200,235,15Z',
			},
			{
				value:
					'M275,31c200,0,139,168,366,299,139,74,111,264,56,326-66,75-217,50-326,50.958C170,708-104,570-104,373.906S75,31,275,31Z',
			},
			{
				value:
					'M275,31c200,0,110,220,300,230,196,74,110,350,10,450-200,163-217,90-300,100.958C170,500-60,150-150,200.906S75,0,150,15Z',
			},
		],
		ease: 'linear',
		duration: 10000,
		loop: true,
		alternate: true,
	});
};

const blobAbout = (targetCSS) => {
	animate(targetCSS, {
		d: [
			{
				value:
					'M215,31c179,0,150,190,315,280,160,90,60,360,120,250-70,120-180,70-330,80.624C141,800-60,540-80,300.3S56,60,360,21Z',
			},
			{
				value:
					'M235,31c179,0,125,184,327,326,125,81,99,288,50,356-59,81-194,55-292,55.624C141,770-104,619-104,405.3S56,31,235,31Z',
			},
			{
				value:
					'M290,31c179,0,90,120,360,326,70,50,160,120,160,230-90,70-150,90-165,55.624C141,600-160,700-160,490.3S56,20,200,46Z',
			},
		],
		ease: 'linear',
		duration: 10000,
		loop: true,
		alternate: true,
	});
};

export { blobTop, blobAbout };
